// Chatbot API Service
import { ApiType } from "./ApiType";

const CHATBOT_BASE_PATH = "/api/chatbot";

/**
 * Get available AI providers (no auth required)
 */
const getProviders = async () => {
    const data = await ApiType.getRequest(`${CHATBOT_BASE_PATH}/providers`);
    return data;
};

/**
 * Start a new chat session
 * @param {string} language - 'english' | 'gujarati' | 'hindi'
 * @param {string} provider - 'openai' | 'gemini' (optional)
 */
const startSession = async (language = "english", provider = "openai") => {
    const data = await ApiType.postRequest(
        `${CHATBOT_BASE_PATH}/session/start`,
        JSON.stringify({ language, provider })
    );
    return data;
};

/**
 * Send a message in an active chat session
 * @param {number} sessionId - The session ID
 * @param {string} message - User's message
 */
const sendMessage = async (sessionId, message) => {
    const data = await ApiType.postRequest(
        `${CHATBOT_BASE_PATH}/message`,
        JSON.stringify({ sessionId, message })
    );
    return data;
};

/**
 * Send a message with an image attachment (multipart/form-data)
 * @param {number} sessionId - The session ID
 * @param {string} message - User's message (optional)
 * @param {File} imageFile - The image file to upload
 */
const sendMessageWithImage = async (sessionId, message, imageFile) => {
    const formData = new FormData();
    formData.append("sessionId", sessionId);
    formData.append("message", message || "");
    formData.append("image", imageFile);

    const data = await ApiType.postRequest(
        `${CHATBOT_BASE_PATH}/message`,
        formData
    );
    return data;
};

/**
 * Generate paper based on chat configuration
 * @param {number} sessionId - The session ID
 */
const generatePaper = async (sessionId) => {
    const data = await ApiType.postRequest(
        `${CHATBOT_BASE_PATH}/generate-paper`,
        JSON.stringify({ sessionId })
    );
    return data;
};

/**
 * End/close a chat session
 * @param {number} sessionId - The session ID
 */
const endSession = async (sessionId) => {
    const data = await ApiType.postRequest(
        `${CHATBOT_BASE_PATH}/session/end`,
        JSON.stringify({ sessionId })
    );
    return data;
};

export const ChatbotApi = {
    getProviders,
    startSession,
    sendMessage,
    sendMessageWithImage,
    generatePaper,
    endSession,
};
